import type { GameState } from '../game/types';

export interface FinancialSnapshot {
  cash: number;
  aircraftAssets: number;
  fuelStorageAssets: number;
  totalAssets: number;
  debt: number;
  netAssets: number;
  weeklyDebtPayment: number;
}

export function buildFinancialSnapshot(game: GameState): FinancialSnapshot {
  const aircraftAssets = game.aircraft.reduce((sum, aircraft) => sum + aircraft.bookValue, 0);
  const fuelStorageAssets = game.fuelStorage.reduce((sum, facility) => sum + facility.bookValue, 0);
  const debt = game.loans.reduce((sum, loan) => sum + loan.principalRemaining, 0);
  return {
    cash: game.cash,
    aircraftAssets,
    fuelStorageAssets,
    totalAssets: game.cash + aircraftAssets + fuelStorageAssets,
    debt,
    netAssets: game.cash + aircraftAssets + fuelStorageAssets - debt,
    weeklyDebtPayment: game.loans.reduce((sum, loan) => sum + loan.weeklyPayment, 0),
  };
}
